import { tv } from "tailwind-variants";
import { t } from "ttag";

import type { MakeOptional } from "@/shared/lib";
import { formatDate, formatTime } from "@/shared/lib";
import {
  CalendarMinimalisticIcon,
  ClockIcon,
  DetailCard,
  UserIcon,
} from "@/shared/ui";
import type { Appointment } from "../models";

const cardStyles = tv({
  slots: {
    root: "min-h-fit border border-neutral-700 bg-white p-4",
    content: "gap-2 p-0 font-medium",
    label: "text-neutral-700",
    icon: "size-4",
    value: "text-neutral-950",
  },
});

const { root, content, label, icon, value } = cardStyles();

interface AppointmentDetailsCardProps {
  appointment: MakeOptional<
    Pick<Appointment, "startTime" | "provider">,
    "provider"
  >;
}

export const AppointmentDetailsCard = ({
  appointment,
}: AppointmentDetailsCardProps) => {
  const { startTime, provider } = appointment;

  return (
    <DetailCard.Root variant="borderLess" className={root()}>
      <DetailCard.Content className={content()}>
        <DetailCard.Description className={label()}>
          <CalendarMinimalisticIcon className={icon()} />
          {t`Chosen date: `}
          <span className={value()}>{formatDate(startTime)}</span>
        </DetailCard.Description>

        <DetailCard.Description className={label()}>
          <ClockIcon className={icon()} />
          {t`Chosen time: `}
          <span className={value()}>{formatTime(startTime)}</span>
        </DetailCard.Description>

        <DetailCard.Description className={label()}>
          <UserIcon className={icon()} />
          {t`Provider: `}
          <span className={value()}>
            {provider?.fullName ?? t`Earliest available`}
          </span>
        </DetailCard.Description>
      </DetailCard.Content>
    </DetailCard.Root>
  );
};
